type VoucherCallToActionSource = {
  voucherCallToAction?: string | null
  voucherCallToActionUrl?: string | null
}

export type VoucherCallToAction = {
  text: string
  url: string
}

function trimConfiguredValue(value: string | null | undefined): string | undefined {
  const trimmed = value?.trim()
  return trimmed && trimmed.length > 0 ? trimmed : undefined
}

export function getVoucherCallToAction(voucher: VoucherCallToActionSource): VoucherCallToAction | undefined {
  const text = trimConfiguredValue(voucher.voucherCallToAction)
  const url = trimConfiguredValue(voucher.voucherCallToActionUrl)
  if (!text || !url) return undefined
  return { text, url }
}

export function isAbsoluteVoucherCallToActionUrl(url: string): boolean {
  return /^https?:\/\//i.test(url)
}
